import Vue from 'vue';
import { CollapsePlugin } from 'bootstrap-vue';

Vue.use(CollapsePlugin);

new Vue({
    el: '#app-collapse'
});
